import debounce from '../utils/debounce';
const equaliseProductHeights = () => {
    const rows = document.querySelectorAll('[data-listing-row]');
    const selectors = [
        'title', 'visual', 'deal-tags', 'oos', 'price', 'mobile-title', 'energy-labels'
    ];
    const applyHeights = (nodes) => {
        if (window.innerWidth < 768) {
            return nodes.forEach(node => node.style.height = 'auto');
        }
        let maxHeight = 0;
        nodes.forEach((node) => {
            node.style.height = 'auto';
            if (node.offsetHeight > maxHeight) {
                maxHeight = node.offsetHeight;
            }
        });
        nodes.forEach(node => node.style.height = `${maxHeight}px`);
    };
    const init = () => rows.forEach(row =>
        selectors.forEach(selector =>
            applyHeights(row.querySelectorAll(`[data-product-${selector}]`))
        )
    );
    window.removeEventListener('resize', debounce(() => init()));
    window.addEventListener('resize', debounce(() => init()));
    window.addEventListener('load', debounce(() => init()));
    init();
};
export default equaliseProductHeights;
